import { attachPageComponent } from '../../route-utils';
import * as routes from './routes';

const { page, ...actionRoutes } = attachPageComponent(routes, import('./SelectMedicineStrength'));

export default page;
export { actionRoutes };
